module.exports = __webpack_public_path__ + "img/eye.33e43412.svg";